<template>
  <div class="contact-wrap bg-background">
    <!-- HERO -->
    <v-container fluid class="hero-section py-16 text-center">
      <h1 class="hero-title">
        Contact Us
      </h1>
    </v-container>
    <v-container fluid>
      <v-container class="contact-inner">
        <v-row class="align-start" no-gutters>

          <!-- LEFT COLUMN: SUPPORT + PARTNERSHIPS CARDS -->
          <v-col cols="12" md="4" class="left-col">
            <!-- Support card -->
            <v-card class="info-card mb-6" elevation="3">
              <div class="info-card-header">
                <v-icon icon="mdi-phone" size="30" />
              </div>
              <v-card-text class="info-card-body">
                <h3 class="info-title">Customer<br />Support Line</h3>
                <p class="info-phone">813-555-1234</p>
              </v-card-text>
            </v-card>

            <!-- Partnerships card -->
            <v-card class="info-card" elevation="3">
              <div class="info-card-header">
                <v-icon icon="mdi-handshake" size="30" />
              </div>
              <v-card-text class="info-card-body">
                <h3 class="info-title">Travel Professionals</h3>
                <p class="info-text">
                  Interested in partnering?<br />
                  Let's get in touch.
                </p>
                <v-btn class="info-cta" color="primary" rounded="pill" height="40">
                  Submit a request
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- RIGHT COLUMN: FORM -->
          <v-col cols="12" md="8" class="right-col">
            <div class="form-panel">
              <div class="form-header">
                <h2 class="form-title">Looking for something else?</h2>
                <p class="form-subtitle">
                  Send us a message and a member of our team will reach out to you soon.
                </p>
              </div>

              <form @submit.prevent="handleSubmit">
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="form.name" label="Name" variant="solo" density="comfortable" rounded="pill"
                      hide-details class="pill-field mb-4" />
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="form.email" label="Email" type="email" variant="solo" density="comfortable"
                      rounded="pill" hide-details class="pill-field mb-4" />
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="form.subject" label="Subject" variant="solo" density="comfortable"
                      rounded="pill" hide-details class="pill-field mb-4" />
                  </v-col>

                  <v-col cols="12">
                    <v-select v-model="form.topic" :items="topics" label="How can we help?" variant="solo"
                      density="comfortable" rounded="pill" hide-details class="pill-field mb-4" />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea v-model="form.message" label="Message" variant="solo" rounded="xl" rows="4" auto-grow
                      hide-details class="pill-field mb-6 message-field" />
                  </v-col>

                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn color="primary" rounded="pill" height="44" min-width="130" type="submit" class="submit-btn">
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ContactUsPage",
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        topic: null,
        message: ''
      },
      topics: [
        'General question',
        'Booking issue',
        'Partnership inquiry',
        'Technical support',
        'Other'
      ]
    };
  },
  methods: {
    handleSubmit() {
      // placeholder submit
      console.log('Submit contact form', this.form);
      // reset if you want:
      // this.form = { name: '', email: '', subject: '', topic: null, message: '' }
    }
  }
};
</script>

<style scoped>
.contact-wrap {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.contact-inner {
  max-width: 1040px;
}

/* LEFT COLUMN CARDS */
.left-col {
  margin-bottom: 32px;
}

.info-card {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.info-card-header {
  background-color: #00a5a5;
  color: #ffffff;
  padding-block: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-card-body {
  padding: 28px 26px 30px;
  text-align: center;
  /* horizontal centering */
  display: flex;
  /* enable flexbox */
  flex-direction: column;
  /* stack title and text vertically */
  align-items: center;
  /* center horizontally */
  justify-content: center;
  /* center vertically */
  min-height: 160px;
  /* ensures consistent height for both cards */
}

.info-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #222222;
}

.info-phone {
  font-weight: 600;
  color: #222222;
}

.info-text {
  color: #555555;
  font-size: 0.95rem;
  margin-bottom: 20px;
}

.info-cta {
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: none;
}

/* RIGHT COLUMN FORM LAYOUT */
.right-col {
  display: flex;
  align-items: flex-start;
}

/* form panel is narrower + shifted right a bit */
.form-panel {
  width: 100%;
  max-width: 560px;
  margin-left: 40px;
  padding-top: 18px;
  /* pulls header down so it lines up with white area of top card */
}

.form-header {
  margin-bottom: 24px;
}

.form-title {
  font-size: 1.7rem;
  font-weight: 700;
  margin-bottom: 6px;
  color: #222222;
}

.form-subtitle {
  font-size: 0.95rem;
  color: #555555;
}

/* pill-style text fields */
.pill-field :deep(.v-field) {
  border-radius: 999px !important;
  background-color: #ffffff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.03);
}

.message-field :deep(.v-field) {
  border-radius: 24px !important;
}

/* submit button bottom-right */
.submit-btn {
  text-transform: none;
  font-weight: 600;
}

/* MOBILE */
@media (max-width: 960px) {
  .right-col {
    margin-top: 32px;
  }

  .form-panel {
    margin-left: 0;
    max-width: 100%;
    padding-top: 0;
  }
}
</style>